import React from 'react';
import { Space } from 'antd';
import { downloadRecordFile } from '../false-deals-admin.utils';
import { FileData } from '../false-deals-admin.types';

export interface AttachmentsListProps {
    files: FileData[];
}

const AttachmentsList = ({ files }: AttachmentsListProps) => {
    return (
        <Space
            size="small"
            direction="vertical"
            style={{ width: 200 }}
        >
            {files?.map((file) => (
                <a
                    key={file.fileId}
                    className="blue-color"
                    onClick={() => downloadRecordFile(file)}
                >
                    {file.fileName}
                </a>
            ))}
        </Space>
    );
};

export default AttachmentsList;
